function initGallery() {
	var gallery = document.getElementById('lightgallery');
	if (gallery) {
		lightGallery(gallery,
			{
				mode: 'lg-fade',
				download: false,
				counter: false
			});

	}
}
